import React, { useState, useEffect } from 'react';
import { FaPrint, FaSync, FaPlus, FaTruck, FaUser, FaCheckCircle, FaFileInvoice, FaTags, FaBoxOpen, FaAlignLeft, FaCheck  } from "react-icons/fa";
import { useParams } from "react-router-dom";
import logo from "../../assets/images/logoemp.png";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
// import "./PurchaseOrderDetail.css";
import './Print.css'; 

const PurchaseOrderDetail = () => {
  const [order, setOrder] = useState({
  sub_amount: 0,
  discount: 0,
  tax: 0,
  products: [],
});
const MySwal = withReactContent(Swal);
const [printMode, setPrintMode] = useState("normal");
const [isReadyToPrint, setIsReadyToPrint] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { poNumber } = useParams();
  // State utama untuk editable mode
  const [alignmentMode, setAlignmentMode] = useState(false);
  // Data produk editable (copy dari order.products saat alignmentMode aktif)
  const [editableProducts, setEditableProducts] = useState([]);
  // Checkbox PPN
  const [withPPN, setWithPPN] = useState(false);
  const [isInitialPPNSet, setIsInitialPPNSet] = useState(false);
  // Total amounts editable
const [totals, setTotals] = useState({
  untaxed: 0,
  taxes: 0,
  total: 0,
});
useEffect(() => {
  if (isReadyToPrint) {
    const timer = setTimeout(() => {
      window.print();
      setIsReadyToPrint(false);
    }, 200);
    return () => clearTimeout(timer);
  }
}, [isReadyToPrint]);

const printNota = () => {
  setPrintMode("nota");
  setIsReadyToPrint(true);
};
const [manualTotals, setManualTotals] = useState({
  sub_amount: null,
  discount: null,
  tax: null,
});

const handlePrintSuratPesanan = () => {
  const printWindow = window.open("", "_blank");
  if (!printWindow) return;

  const products = alignmentMode ? editableProducts : order.products || [];

  const tableRows = products
    .map((p, index) => {
      const priceQty = (p.price || 0) * (p.qty || 0);
      const discountAmount = p.discountAmount || 0;
      const discountPercent = priceQty > 0 ? ((discountAmount / priceQty) * 100).toFixed(1) : 0;
      const finalSubtotal = priceQty - discountAmount;

      return `
        <tr>
          <td style="border: 1px solid #cbd5e1; padding: 7px; text-align: center;">${index + 1}</td>
          <td style="border: 1px solid #cbd5e1; padding: 7px; font-weight: bold;">${p.name}</td>
          <td style="border: 1px solid #cbd5e1; padding: 7px; text-align: right; font-family: monospace;">Rp ${(p.price || 0).toLocaleString("id-ID")}</td>
          <td style="border: 1px solid #cbd5e1; padding: 7px; text-align: center; font-weight: bold;">${p.qty}</td>
          <td style="border: 1px solid #cbd5e1; padding: 7px; text-align: center;">${discountPercent}%</td>
          <td style="border: 1px solid #cbd5e1; padding: 7px; text-align: right; font-family: monospace; font-weight: bold;">Rp ${finalSubtotal.toLocaleString("id-ID")}</td>
        </tr>
      `;
    })
    .join("");

  const calculatedUntaxed = products.reduce((sum, p) => sum + (p.price * p.qty - (p.discountAmount || 0)), 0);
  const calculatedTax = withPPN ? Math.round(calculatedUntaxed * 0.11) : 0;
  const calculatedGrandTotal = calculatedUntaxed + calculatedTax;

  const html = `
    <!DOCTYPE html>
    <html>
      <head>
        <title>Surat Pesanan - ${order.id || "PO"}</title>
        <style>
          body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; padding: 30px; color: #1e293b; background: #fff; }
          .header-kop { border-bottom: 3px double #059669; padding-bottom: 12px; margin-bottom: 20px; display: flex; justify-content: space-between; align-items: flex-end; }
          .header-kop h1 { margin: 0; font-size: 24px; color: #059669; font-weight: 800; text-transform: uppercase; letter-spacing: 0.5px; }
          .header-kop p { margin: 3px 0 0 0; font-size: 12px; color: #64748b; }
          .po-badge { background-color: #ecfdf5; color: #047857; border: 1px solid #a7f3d0; padding: 6px 14px; border-radius: 12px; font-weight: bold; font-family: monospace; font-size: 13px; }
          
          .info-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 15px; margin-bottom: 20px; font-size: 12px; }
          .info-card { background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 12px; padding: 12px 16px; }
          .info-card h3 { margin: 0 0 6px 0; font-size: 11px; text-transform: uppercase; color: #059669; letter-spacing: 0.5px; font-weight: 800; }
          .info-card p { margin: 2px 0; font-size: 12px; color: #334155; }

          .data-table { width: 100%; border-collapse: collapse; font-size: 11px; margin-top: 10px; }
          .data-table th { background-color: #ecfdf5; color: #065f46; border: 1px solid #a7f3d0; padding: 8px; text-align: center; text-transform: uppercase; font-size: 10px; letter-spacing: 0.5px; }
          
          .summary-table { width: 300px; margin-left: auto; margin-top: 15px; font-size: 12px; border-collapse: collapse; }
          .summary-table td { padding: 5px 8px; }
          .summary-table td.total-label { font-weight: bold; color: #1e293b; }
          .summary-table td.grand-total { font-size: 15px; font-weight: 800; color: #047857; border-top: 2px solid #059669; }

          .signature-section { margin-top: 50px; display: flex; justify-content: space-between; font-size: 11px; text-align: center; }
          .signature-box { width: 220px; }
          .signature-space { height: 65px; }
        </style>
      </head>
      <body>
        <div class="header-kop">
          <div>
            <h1>Apotek Djaya Medika</h1>
            <p>Surat Pesanan (PO) & Pengadaan Obat PBF</p>
          </div>
          <div class="po-badge">NO: ${order.id || "-"}</div>
        </div>

        <div class="info-grid">
          <div class="info-card">
            <h3>Kepada Yth. (Supplier / Distributor PBF)</h3>
            <p><strong>${order.from?.name || "-"}</strong></p>
            <p>${order.from?.address || "-"}</p>
            <p>Telepon/Kontak: ${order.from?.contact || "-"}</p>
          </div>
          <div class="info-card">
            <h3>Tujuan Pengiriman (Outlet / Apotek)</h3>
            <p><strong>${order.to?.name || "-"}</strong></p>
            <p>${order.to?.address || "-"}</p>
            <p>Telepon/Kontak: ${order.to?.contact || "-"}</p>
          </div>
        </div>

        <div style="font-size: 12px; margin-bottom: 15px;">
          <div><strong>Tanggal SP:</strong> ${order.date || "-"}</div>
        </div>

        <table class="data-table">
          <thead>
            <tr>
              <th style="width: 35px;">No</th>
              <th>Nama Produk Obat</th>
              <th style="width: 110px;">Harga Satuan</th>
              <th style="width: 60px;">Qty</th>
              <th style="width: 70px;">Diskon</th>
              <th style="width: 120px;">Subtotal</th>
            </tr>
          </thead>
          <tbody>
            ${tableRows || `<tr><td colspan="6" style="text-align:center; padding: 15px;">Tidak ada item obat</td></tr>`}
          </tbody>
        </table>

        <table class="summary-table">
          <tr>
            <td class="total-label">Subtotal Obat:</td>
            <td style="text-align: right; font-family: monospace;">Rp ${calculatedUntaxed.toLocaleString("id-ID")}</td>
          </tr>
          ${
            withPPN
              ? `
          <tr>
            <td class="total-label">PPN (11%):</td>
            <td style="text-align: right; font-family: monospace;">Rp ${calculatedTax.toLocaleString("id-ID")}</td>
          </tr>
          `
              : ""
          }
          <tr>
            <td class="total-label grand-total">Grand Total:</td>
            <td class="grand-total" style="text-align: right; font-family: monospace;">Rp ${calculatedGrandTotal.toLocaleString("id-ID")}</td>
          </tr>
        </table>

        <div class="signature-section">
          <div class="signature-box">
            <p style="font-weight: bold; margin-bottom: 4px;">Pembuat Surat Pesanan</p>
            <div class="signature-space"></div>
            <p>( .................................... )</p>
          </div>
          <div class="signature-box">
            <p style="margin: 0; font-size: 11px;">Hormat Kami,</p>
            <p style="font-weight: bold; margin: 2px 0 4px 0;">Apoteker Penanggung Jawab</p>
            <div class="signature-space"></div>
            <p style="font-weight: bold; margin-bottom: 2px;">( apt. Wahyu Wijayanti, S.Farm )</p>
            <p style="margin: 0; font-size: 10px; color: #475569;">No SIPA: 19910704/SIPA035.06/2024/2859</p>
          </div>
        </div>
      </body>
    </html>
  `;

  printWindow.document.write(html);
  printWindow.document.close();
  printWindow.print();
};

const fetchOrderDetail = async () => {
  setIsLoading(true);
  const token = localStorage.getItem("token");
  const encodedPoNumber = encodeURIComponent(poNumber);
  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/v1/purchasing-order/${encodedPoNumber}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await response.json();
    if (result.data) {
      const data = result.data;
      // Inisialisasi PPN hanya sekali
      if (!isInitialPPNSet) {
        const taxExists = data.tax > 0;
        setWithPPN(taxExists);
        setIsInitialPPNSet(true);
      }
     const mappedProducts = data.items.map((item, index) => {
  return {
    no: index + 1,
    id: item.id,
    id_obat: item.obat.id,
    name: item.obat.name,
    price: item.price,
    qty: item.qty,
    subtotal: item.subtotal,        
    discountAmount: item.discount,
    discountPercent: item.price * item.qty > 0
      ? (item.discount / (item.price * item.qty)) * 100
      : 0,
    originalSubtotal: item.price * item.qty,
  };
});


      setOrder({
  id: data.number,
  date: new Date(data.created_at).toLocaleString("id-ID"),
  status: data.status.charAt(0).toUpperCase() + data.status.slice(1),
  from: {
    name: `${data.distributor?.name || "Distributor"} - ${data.distributor?.kota || "Pusat"}`,
    address: data.distributor?.alamat || data.distributor?.address || "-",
    contact: `${data.distributor?.telepon || data.distributor?.phone || "-"}, ${data.distributor?.email || "-"}`,
  },
  to: {
    name: `${data.outlet?.name || "Outlet"} - ${data.outlet?.kota || "Pusat"}`,
    address: data.outlet?.alamat || data.outlet?.address || "-",
    contact: `${data.outlet?.telepon || data.outlet?.phone || "-"}, ${data.outlet?.email || "-"}`,
  },
  invoices: (data.invoices || []).map((inv) => ({
    id: inv.number || inv.id,
    amount: inv.amount,
  })),

  creator: data.created_by?.fullname || data.created_by?.name || "Owner",
  method: data.method ? data.method.charAt(0).toUpperCase() + data.method.slice(1) : "Cash",
  approvedBy: data.approved_by?.fullname || data.approved_by?.name || "Owner",
  products: mappedProducts,
  sub_amount: Number(data.sub_amount) || 0,  
  original_amount: mappedProducts.reduce((sum, p) => sum + p.originalSubtotal, 0), 
  discount: data.discount,
  tax: data.tax,
  description: data.description,
  totals: {
    untaxed: Number(data.sub_amount) || 0,
    taxes: data.tax,
    total: data.total_amount,
  },
});


      // Set editableProducts jika alignmentMode aktif
      setEditableProducts(mappedProducts);
    }
  } catch (error) {
    console.error("Failed to fetch order detail:", error);
  } finally {
    setIsLoading(false);
  }
};
useEffect(() => {
  if (poNumber) fetchOrderDetail();
}, [poNumber]);

// Hitung ulang totals saat withPPN atau sub_amount berubah
React.useEffect(() => {
  const untaxed = order?.sub_amount || 0;
  const tax = withPPN ? Math.round(untaxed * 0.11) : 0;
  const total = untaxed + tax;

  setTotals({
    untaxed,
    taxes: tax,
    total,
  });
}, [withPPN, order?.sub_amount]);
  // Saat alignmentMode aktif, copy produk ke editableProducts
  useEffect(() => {
    if (alignmentMode && order) {
      setEditableProducts(order.products.map((p) => ({ ...p })));
    } else {
      setEditableProducts([]);
      // Reset dengan data order asli saat non-editable
      if (order) {
        setTotals(order.totals);
      }
    }
  }, [alignmentMode, order]);
  // Fungsi untuk update harga semua produk jika satu harga diubah (sync harga)
const handlePriceChange = (index, newPrice) => {
  const updated = [...editableProducts];
  const product = updated[index];
  const newSubtotal = newPrice * product.qty;

  updated[index] = {
    ...product,
    price: newPrice,
    subtotal: newSubtotal,
  };

  setEditableProducts(updated);
  recalcTotals(updated);
};
const handleDiscountChange = (index, newDiscountAmount) => {
  const updated = [...editableProducts];
  const product = updated[index];
  const priceQty = product.price * product.qty;
  const discountAmount = Math.min(newDiscountAmount, priceQty); 
  const discountPercent = priceQty > 0 ? (discountAmount / priceQty) * 100 : 0;
  const subtotal = priceQty - discountAmount;

  updated[index] = {
    ...product,
    discountAmount,
    discountPercent,
    subtotal,
  };

  setEditableProducts(updated);
  recalcTotals(updated);
};
const handleSubmitAlignment = async () => {
  try {
    // Hitung total subtotal sebelum diskon
    const subAmount = editableProducts.reduce(
      (sum, item) => sum + item.price * item.qty,
      0
    );

    // Hitung total diskon per produk
    const totalDiscount = editableProducts.reduce(
      (sum, item) => sum + (item.discountAmount || 0),
      0
    );

    // Hitung pajak (PPN) hanya jika withPPN = true
    const totalTax = withPPN
      ? editableProducts.reduce(
          (sum, item) =>
            sum +
            ((item.price * item.qty - (item.discountAmount || 0)) * 0.11),
          0
        )
      : 0;

    // Total akhir setelah diskon + pajak
    const totalAmount = subAmount - totalDiscount + totalTax;

    // Buat payload dengan angka dibulatkan 2 desimal
    const payload = {
      sub_amount: parseFloat(subAmount.toFixed(2)),
      discount: parseFloat(totalDiscount.toFixed(2)),
      tax: parseFloat(totalTax.toFixed(2)),
      amount: parseFloat(totalAmount.toFixed(2)),
      items: editableProducts.map((item) => {
        const price = parseFloat(item.price.toFixed(2));
        const qty = parseFloat(item.qty.toFixed(2));
        const discount = parseFloat((item.discountAmount || 0).toFixed(2));
        const subtotal = parseFloat(
          (item.price * item.qty - (item.discountAmount || 0)).toFixed(2)
        );
        const tax = withPPN
          ? parseFloat(
              ((item.price * item.qty - (item.discountAmount || 0)) * 0.11).toFixed(2)
            )
          : 0;

        return {
          id: item.id,
          price,
          qty,
          discount,
          subtotal,
          tax,
        };
      }),
    };

    console.log("Payload Alignment:", payload); // Debug log

    // Kirim ke API
    const res = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/v1/purchasing-order/${encodeURIComponent(order.id)}/alignment`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(payload),
      }
    );

    if (!res.ok) throw new Error("Gagal menyimpan alignment");

    // ✅ Pop-up sukses
    MySwal.fire({
      icon: "success",
      title: "Berhasil!",
      text: "Alignment berhasil disimpan",
      showConfirmButton: false,
      timer: 2000,
    });

    setAlignmentMode(false);
    await fetchOrderDetail(); // Refresh data dari server
  } catch (err) {
    console.error(err);

    // ❌ Pop-up error
    MySwal.fire({
      icon: "error",
      title: "Oops...",
      text: "Terjadi kesalahan saat submit alignment",
    });
  }
};

useEffect(() => {
  if (order?.products) {
    const initialEditableProducts = order.products.map(prod => ({
      ...prod,
      discountAmount: prod.discountAmount !== undefined ? prod.discountAmount : order.discount || 0,
    }));
    setEditableProducts(initialEditableProducts);
  }
}, [order]);
  // Fungsi untuk update subtotal dan hitung diskon otomatis
const handleSubtotalChange = (index, newSubtotal) => {
  const updated = [...editableProducts];
  const product = updated[index];
  const originalTotal = product.price * product.qty;
  const validSubtotal = isNaN(newSubtotal) ? 0 : newSubtotal;
  const discountAmount = originalTotal - validSubtotal;
  const discountPercent = discountAmount > 0 ? (discountAmount / originalTotal) * 100 : 0;
  updated[index] = {
    ...product,
    subtotal: validSubtotal,
    discountAmount,
    discountPercent,
  };
  setEditableProducts(updated);
  recalcTotals(updated);
};
  // Fungsi hitung ulang total untaxed, pajak, dan total akhir
  const recalcTotals = (products) => {
  const originalUntaxed = products.reduce((sum, p) => sum + (p.originalSubtotal || (p.price * p.qty)), 0);
  const untaxed = products.reduce((sum, p) => sum + (p.subtotal || 0), 0);
  const tax = untaxed * 0.11; // contoh PPN 11%
  const total = untaxed + tax;

  setTotals({ untaxed, taxes: tax, total });
  setOrder((prev) => ({
    ...prev,
    products,
    sub_amount: untaxed,
    original_amount: originalUntaxed,
    discount: products.reduce((sum, p) => sum + (p.discountAmount || 0), 0),
    tax,
    totals: { untaxed, taxes: tax, total },
  }));
};
  if (isLoading) return <p>Loading...</p>;
  if (!order) return <p>Order not found</p>;
const handleApprove = async (id) => {
  const token = localStorage.getItem("token"); 
  if (!token) {
    MySwal.fire({
      icon: "error",
      title: "Token tidak ditemukan",
      text: "Silakan login kembali.",
    });
    return;
  }
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/v1/purchasing-order/${encodeURIComponent(id)}/approve`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, 
        },
      }
    );
    if (!response.ok) throw new Error("Gagal meng-approve PO.");

    MySwal.fire({
      icon: "success",
      title: "PO berhasil di-approve!",
      showConfirmButton: false,
      timer: 2000,
    });

    window.location.reload(); 
  } catch (error) {
    console.error(error);
    MySwal.fire({
      icon: "error",
      title: "Oops...",
      text: "Terjadi kesalahan saat meng-approve PO.",
    });
  }
};

  return (
<div id="printable-area" className={`... ${printMode === 'nota' ? 'hidden-print' : ''}`}>
      <h1 className="text-3xl font-bold text-gray-800 flex items-center gap-2">
        <FaTruck className="text-green-500" /> Purchasing Order
      </h1>
      <div className="mt-6 bg-white p-6 rounded-2xl shadow-lg">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:justify-between gap-4 items-start md:items-center">
<h2 className="text-2xl font-bold text-gray-800 flex items-center gap-3">
  {order.id}
  <span
    className={`px-3 py-1 rounded-full text-sm font-semibold ${
      order.status === "Approved"
        ? "bg-green-100 text-green-700"
        : order.status === "Pending"
        ? "bg-yellow-100 text-yellow-700"
        : order.status === "Received"
        ? "bg-blue-100 text-blue-700"
        : "bg-gray-100 text-gray-700"
    }`}
  >
    {order.status}
  </span>

  {/* Tambahkan tombol invoice di sini */}
  {order.status === "Approved" && (
    <button
  className="ml-3 px-2.5 py-1.5 bg-indigo-600 hover:bg-indigo-700 text-white text-sm rounded-full flex items-center gap-1.5 shadow-sm"
  onClick={() => {
    sessionStorage.setItem("previousPage", window.location.href);
    window.location.href = `/inventory/invoice/form/${encodeURIComponent(order.id)}`;
  }}
  disabled={alignmentMode}
>
  <FaPlus className="text-xs" /> Buat Invoice
</button>

  )}
</h2>

          <div className="flex gap-3 flex-wrap">
            <button
              onClick={() => setAlignmentMode(true)}
              disabled={alignmentMode}
              className={`px-4 py-2 bg-yellow-600 hover:bg-yellow-700 text-white rounded-full flex items-center gap-2 shadow-md ${
                alignmentMode ? "opacity-50 pointer-events-none" : ""
              }`}
            >
              <FaAlignLeft /> Alignment
            </button>

            {alignmentMode && (
              <button
                onClick={() => setAlignmentMode(false)}
                className="px-4 py-2 bg-gray-400 text-white rounded-full flex items-center gap-2 shadow-md"
              >
                Cancel Alignment
              </button>
            )}

            {alignmentMode && (
        <button
          onClick={handleSubmitAlignment}
          className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-full flex items-center gap-2 shadow-md"
        >
          <FaCheck /> Submit Alignment
        </button>
      )}
      <button
          onClick={() => window.location.reload()}
          disabled={alignmentMode}
          className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-full flex items-center gap-2 shadow-md disabled:opacity-50"
        >
          <FaSync /> Refresh
        </button>
        {order.status === "Pending" && (
          <button
            onClick={() => handleApprove(order.id)}
            disabled={alignmentMode}
            className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-full shadow-md flex items-center gap-2 disabled:opacity-50"
          >
            <FaCheckCircle /> Approve
          </button>
        )}
        {order.status === "Approved" && (
          <a
            href={`/inventory/purchase-order/receive/${encodeURIComponent(order.id)}`} 
            className="px-4 py-2 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-md flex items-center gap-2"
          >
            <FaBoxOpen /> Receive
          </a>
        )}
        <button
          onClick={handlePrintSuratPesanan}
          className="px-5 py-2.5 bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-700 hover:to-teal-700 text-white rounded-2xl flex items-center gap-2 shadow-lg shadow-emerald-600/20 text-xs font-bold transition-all disabled:opacity-50"
        >
          <FaPrint className="w-3.5 h-3.5" />
          <span>Cetak</span>
        </button>
        {/* {order.status === "Approved" && (
          <button
            className="px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-full flex items-center gap-2 shadow-md"
            onClick={() => {
              sessionStorage.setItem("previousPage", window.location.href);
              window.location.href = `/inventory/invoice/form/${encodeURIComponent(order.id)}`;
            }}
            disabled={alignmentMode}
          >
            <FaPlus /> Buat Invoice
          </button>
        )} */}
      </div>
    </div>
    {/* Info Header */}
    <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-6">
      <div>
        <h3 className="font-bold text-gray-700 flex items-center gap-2"><FaUser /> Dari</h3>
        <p className="text-gray-900">{order.to.name}</p>
        <p className="text-gray-700">{order.to.address}</p>
        <p className="text-gray-700">{order.to.contact}</p>
      </div>
      <div>
        <h3 className="font-bold text-gray-700 flex items-center gap-2"><FaTruck /> Tujuan</h3>
         <p className="text-gray-900">{order.from.name}</p>
        <p className="text-gray-700">{order.from.address}</p>
        <p className="text-gray-700">{order.from.contact}</p>
      </div>
      <div>
  <h3 className="font-bold text-gray-700 flex items-center gap-2">
    <FaFileInvoice /> Invoice
  </h3>
  {order.invoices.length > 0 ? (
    <>
      <ul className="mt-2 space-y-1">
  {order.invoices.map((inv) => (
    <li key={inv.id} className="flex justify-between text-gray-900">
      <span>{inv.id}</span>
      <span>
        Rp {inv.amount.toLocaleString("id-ID", {  })}
      </span>
    </li>
  ))}
</ul>
<div className="border-t mt-2 pt-2 flex justify-between font-semibold text-gray-800">
  <span>TOTAL</span>
  <span>
    Rp{" "}
    {order.invoices
      .reduce((sum, inv) => sum + (Number(inv.amount) || 0), 0)
      .toLocaleString("id-ID", {  })}
  </span>
</div>

    </>
  ) : (
    <p className="text-gray-600">No invoices available</p>
  )}
</div>
    </div>
    {/* Creator & Method */}
    <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-6">
      <div>
        <h4 className="font-semibold text-gray-700">Created By</h4>
        <p className="text-gray-900">{order.creator}</p>
      </div>
      <div>
        <h4 className="font-semibold text-gray-700">Method</h4>
        <p className="text-gray-900">{order.method}</p>
      </div>
      <div>
        <h4 className="font-semibold text-gray-700">Approved By</h4>
        <p className="text-gray-900">{order.approvedBy}</p>
      </div>
      <div>
        <h4 className="font-semibold text-gray-700">Date</h4>
        <p className="text-gray-900">{order.date}</p>
      </div>
    </div>
{alignmentMode && (
  <div className="mt-4 flex items-center gap-2">
    <input
      type="checkbox"
      id="with-ppn"
      checked={!withPPN} // dibalik
      onChange={(e) => {
        console.log("PPN checkbox clicked, value:", e.target.checked);
        setWithPPN(!e.target.checked); // dibalik
      }}
    />
    <label htmlFor="with-ppn" className="select-none">
      Tanpa PPN (centang jika tidak pakai PPN)
    </label>
  </div>
)}

    {/* Products Table */}
<div className="mt-6 overflow-x-auto rounded-xl shadow border border-gray-200">
  <table className="min-w-full divide-y divide-gray-200 text-sm">
    <thead className="bg-green-100 text-gray-900">
      <tr>
        <th className="w-10 text-center py-3" rowSpan="2">No</th>
        <th className="w-64 text-center py-3" rowSpan="2">Product Name</th>
        <th className="w-32 text-center py-3" rowSpan="2">Price</th>
        <th className="w-20 text-center py-3" rowSpan="2">Qty</th>
        <th className="py-2 text-center" colSpan="2">Discount</th>
        <th className="w-52 text-center py-3" rowSpan="2">Subtotal</th>
      </tr>
      <tr>
        <th className="py-2 text-center w-16">%</th>
        <th className="py-2 text-center w-28">Amount</th>
      </tr>
    </thead>
    <tbody className="divide-y divide-gray-100 bg-white">
      {(alignmentMode ? editableProducts : order?.products || []).map((product, i) => {
        const priceQty = product.price * product.qty;
        const discountAmountPerProduct = product.discountAmount || 0;
        const discountPercent = priceQty > 0 
          ? Number(((discountAmountPerProduct / priceQty) * 100).toFixed(2)) 
          : 0;
        const finalSubtotal = Number((priceQty - discountAmountPerProduct).toFixed(0));

        return (
          <tr key={i} className="hover:bg-gray-50">
            <td className="text-center p-2">{product.no}</td>
            <td className="text-center text-gray-700 p-2">{product.name}</td>
            
            {/* Price */}
            <td className="text-center p-2">
              {alignmentMode ? (
                <input
                  type="number"
                  className="w-full p-1 border rounded"
                  value={product.price}
                  min={0}
                  onChange={(e) => handlePriceChange(i, parseFloat(e.target.value))}
                />
              ) : (
                `Rp ${product.price.toLocaleString("id-ID", {  })}`
              )}
            </td>

            {/* Qty */}
            <td className="text-center p-2">{product.qty}</td>

            {/* Discount % */}
            <td className="text-center p-2">
              {alignmentMode ? (
                <input
                  type="number"
                  className="w-full p-1 border rounded"
                  value={discountPercent === 0 ? "" : discountPercent}
                  min={0}
                  step={0.01}
                  onChange={(e) => {
                    const newPercent = parseFloat(e.target.value) || 0;
                    const newDiscountAmount = Number(((newPercent / 100) * priceQty).toFixed(2));
                    handleDiscountChange(i, newDiscountAmount);
                  }}
                />
              ) : (
                `${discountPercent}%`
              )}
            </td>

            {/* Discount Amount */}
            <td className="text-center p-2">
              {alignmentMode ? (
                <input
                  type="number"
                  step="0.01"
                  className="w-full p-1 border rounded"
                  value={(discountAmountPerProduct || 0).toFixed(2)}
                  min={0}
                  onChange={(e) => {
                    const newDiscountAmount = parseFloat(e.target.value) || 0;
                    const roundedDiscount = Math.round(newDiscountAmount * 100) / 100;
                    handleDiscountChange(i, roundedDiscount);
                  }}
                />
              ) : (
                `Rp ${discountAmountPerProduct.toLocaleString("id-ID", {  })}`
              )}
            </td>

            {/* Subtotal */}
           {/* Subtotal */}
<td className="text-center p-2 font-semibold">
  {discountAmountPerProduct > 0 ? (
    <div className="flex flex-col items-center">
      <span className="line-through text-gray-500">
        Rp {priceQty.toLocaleString("id-ID", {  })}
      </span>
      <span className="text-gray-800 font-bold">
        Rp {finalSubtotal.toLocaleString("id-ID", {  })}
      </span>
    </div>
  ) : (
    <span>
      Rp {finalSubtotal.toLocaleString("id-ID", {  })}
    </span>
  )}
</td>

          </tr>
        );
      })}
    </tbody>
  </table>
</div>

{/* Totals */}
{/* Totals */}
<div className="mt-6 text-right space-y-1 font-semibold text-gray-800">
  {/* Sebelum diskon */}
  <div>
    Untaxed Amount (Before Discount): Rp{" "}
    {(order?.original_amount ?? 0).toLocaleString("id-ID", {
      
    })}
  </div>

  {/* Sesudah diskon */}
  <div>
    Untaxed Amount (After Discount): Rp{" "}
    {(
      (order?.original_amount ?? 0) - (order?.discount ?? 0)
    ).toLocaleString("id-ID", {
      
    })}
  </div>

  {/* Pajak */}
  <div>
    Taxes (PPN 11%): Rp{" "}
    {(totals?.taxes ?? 0).toLocaleString("id-ID", {
      
    })}
  </div>

  {/* Diskon */}
  <div>
    Diskon: Rp{" "}
    {(order?.discount ?? 0).toLocaleString("id-ID", {
     
    })}
  </div>

  {/* Total */}
  <div className="text-xl">
    Total Amount: Rp{" "}
    {(totals?.total ?? 0).toLocaleString("id-ID", {
      
    })}
  </div>

</div>
    {/* Description */}
    <div className="mt-6">
      <h3 className="font-semibold text-gray-700 mb-1">Description</h3>
      <p className="whitespace-pre-wrap text-gray-700">{order.description}</p>
    </div>
  </div>
<div
  id="nota-print"
  className={`hidden print:block ${printMode !== "nota" ? "hidden" : ""}`}
>
  {/* Header Nota */}
  <div className="text-center mb-2">
    <img src={logo} alt="Logo" className="w-12 mx-auto mb-1" />
    <div className="font-bold text-sm">APOTEK DJAYA MEDICA</div>
    <div>Apoteker: apt. Wahyu Wijayanti, S.Farm</div>
    <div>No SIPA: 19910704/SIPA035.06/2024/2859</div>
    <div>No SIA: 05122400440170001</div>
  </div>

  {/* Info Nota */}
  <div className="flex justify-between text-xs mt-2 border-t border-b py-1">
    <div>
      <div>No: {order.id}</div>
      <div>Kepada: {order.from?.name}</div>
    </div>
    <div className="text-right">
      <div>Kediri</div>
      <div>{order.date}</div>
    </div>
  </div>

  {/* Tabel Produk */}
  <table className="w-full border-collapse mt-2">
    <thead>
      <tr className="border-b border-t text-left">
        <th className="pr-1">No</th>
        <th className="pr-1">Nama</th>
        <th className="pr-1">Qty</th>
      </tr>
    </thead>
    <tbody>
      {order.products.map((item, i) => (
        <tr key={i}>
          <td>{i + 1}</td>
          <td>{item?.name || "-"}</td>
          <td>{item?.qty || "-"}</td>
        </tr>
      ))}
    </tbody>
  </table>

  {/* Footer Nota */}
  <div className="mt-6 text-right text-xs">
    Hormat Kami,<br />
    Apoteker Penanggung Jawab<br />
    <div style={{ height: "1.5cm" }} />
    ( apt. Wahyu Wijayanti, S.Farm )<br />
    No SIPA: 19910704/SIPA035.06/2024/2859
  </div>
</div>

</div>
  );
};

export default PurchaseOrderDetail;
